<div class="card" [ngClass]="{'is-collapsed': collapsed, 'active': !collapsed}">
  <ng-content></ng-content>
</div>


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/pro/accordion/components/sb-item.html